import type { ZodSafeParseResult } from 'zod';
import { cn } from '@/core/ui';

export const FormError = ({ result }: { result: ZodSafeParseResult<any> }) => {
  return (
    <div
      className={cn(
        'prose prose-sm h-[60vh] mt-6 overflow-y-auto',
        'scrollbar-thin scrollbar-thumb-default-200 scrollbar-track-default-100',
      )}
    >
      {result.success ? (
        <div className='text-success-700 bg-success-50 border border-success-200 rounded-lg p-4 shadow-sm text-xs'>
          <strong>Form is valid!</strong>
        </div>
      ) : (
        <div className='bg-warning-50 border border-warning-200 rounded-lg p-4 shadow-sm'>
          <div className='text-warning-800 text-sm leading-relaxed'>
            {result.error.issues.map((issue, idx) => (
              <div key={issue.path?.join('.') + issue.message} className='mb-2'>
                {idx + 1}. &nbsp;
                <span className='font-semibold text-warning-900'>
                  {issue.path && issue.path.length > 0 ? `${issue.path.join(' › ')}: ` : 'General: '}
                </span>
                <span>{issue.message}</span>
                {issue.code && <span className='text-[10px] text-default-500 ml-2'>({issue.code})</span>}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};
